import { Routes } from '@angular/router';
import { SignComponent } from './sign/sign.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { YourCaseComponent } from './your-case/your-case.component';
import { LoginComponent } from './login/login.component';
import { VerifyComponent } from './verify/verify.component';
import { ErrorComponent } from './error/error.component';
import { AdminComponent } from './admin/admin.component';
import { PartnerRedirectComponent } from './partner-redirect/partner-redirect.component';
import { SignupComponent } from './signup/signup.component';
import { signupAddressGuard } from './signup/address/signup-address.guard';
import { EnrolledComponent } from './signup/enrolled/enrolled.component';
import { enrolledGuard } from './signup/enrolled/enrolled.guard';
import { TooManyRequestsComponent } from './signup/errors/too-many-requests.component';
import {
  authGuard,
  rootRedirectGuard,
  addressGuard,
  assessmentGuard,
  profileGuard,
  adminGuard,
  floridaPartnerGuard,
  nonFloridaGuard,
  profileRefreshGuard,
} from './auth.guard';

export const routes: Routes = [
  { path: '', canActivate: [rootRedirectGuard], children: [] },
  { path: 'login', component: LoginComponent },
  { path: 'verify', component: VerifyComponent },
  // Re-checked on query-param changes too, so /signup never renders without a full address
  {
    path: 'signup', component: SignupComponent,
    canActivate: [signupAddressGuard], runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  // The thank-you page once /signup's enrollment is submitted
  { path: 'enrolled', component: EnrolledComponent, canActivate: [enrolledGuard] },
  // Where a throttled (429) /signup request lands (see signupThrottleInterceptor)
  { path: 'too-many-requests', component: TooManyRequestsComponent },
  { path: 'error', component: ErrorComponent },
  // No addressGuard/assessmentGuard here: PartnerRedirectComponent reads neither, and a
  // user with a partner lead may legitimately have no property or assessment row of ours —
  // those guards would bounce them to /error on a page that never needed the data.
  { path: 'partner', component: PartnerRedirectComponent, canActivate: [authGuard, profileRefreshGuard, nonFloridaGuard] },
  { path: 'confirm', component: ConfirmComponent, canActivate: [authGuard, floridaPartnerGuard, addressGuard, assessmentGuard, profileGuard] },
  { path: 'sign', component: SignComponent, canActivate: [authGuard, floridaPartnerGuard, addressGuard, assessmentGuard, profileGuard] },
  { path: 'your-case', component: YourCaseComponent, canActivate: [authGuard, floridaPartnerGuard, addressGuard, assessmentGuard, profileGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] },
  { path: '**', redirectTo: 'login' },
];
